import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiSearchArticlesQueryBody,
  IApiSearchArticlesResponseBody,
} from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseSearchArticlesQueryValues = {
  appId: string;
  body: IApiSearchArticlesQueryBody;
};

export const searchArticlesQueryKeyFactory: IQueryKeyFactory<
  IUseSearchArticlesQueryValues
> = (values) => values && ['searchArticles', values.appId, values.body];

export const useSearchArticlesQuery = (
  values?: IUseSearchArticlesQueryValues,
  options?: UseQueryOptions<IApiSearchArticlesResponseBody, ApiError>,
): UseQueryResult<IApiSearchArticlesResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: searchArticlesQueryKeyFactory(values),
    queryFn: values
      ? () => api.articles.search(values.appId, values.body)
      : undefined,
    ...options,
  });
};
